import { PharmaPilotDrug } from '../../../types';

export type CashPayMetadata = {
  is_appeal_after_discount_price_selection: boolean;
  is_cash_price_consent_requested: boolean;
  is_cash_price_not_affordable: boolean;
};

export const getAppealActionLabel = (
  baseAction: string,
  pilotDrugName?: string,
  cashPayMetadata?: CashPayMetadata,
): string => {
  if (pilotDrugName === PharmaPilotDrug.DUPIXENT) {
    return baseAction;
  }

  if (pilotDrugName === PharmaPilotDrug.OPZELURA) {
    return `${baseAction} and enroll patient in Bridge, if available`;
  }

  if (pilotDrugName === PharmaPilotDrug.ZORYVE && cashPayMetadata?.is_appeal_after_discount_price_selection) {
    if (cashPayMetadata.is_cash_price_consent_requested) {
      return `${baseAction} and send to pharmacy for cash price`;
    } else if (cashPayMetadata.is_cash_price_not_affordable) {
      return `${baseAction} and enroll patient in Patient Assistance (PAP), if available`;
    } else {
      return `${baseAction} and continue with cash price`;
    }
  }

  return `${baseAction} and enroll patient in Bridge or Patient Assistance (PAP), if available`;
};
